<template>
  <vue-page-transition name="fade-in-down">
    <v-content class="bg-content">
      <div class="about">
        <v-container grid-list-xl style="padding: 0px; top:-20px">
          <v-layout row wrap>
            <v-flex sm12 xs12 md12 lg12>
              <v-card class="theme-bg-card-2 card-animate-2">
                <v-img height="200" src="../assets/assets/CFBG2.png"></v-img>
                <v-row style="margin:2.5%;position:absolute; top: 10px">
                  <v-list-item>
                    <v-list-item-avatar size="100">
                      <img v-bind:src="userInfo.profilePic" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        class="title"
                        style="margin-top:10px; color: #ffffff"
                        >{{ userInfo.name }}</v-list-item-title
                      >
                      <v-list-item-subtitle style=" color: #ffffff"
                        >{{ userInfo.position }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-row>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <div class="card-animate-2">
        <v-container grid-list-xl fluid style="padding: 55px; top: 130px">
          <v-card dark class="theme-bg-card-2 card-animate-2">
            <v-app-bar
              color="rgba(12, 22, 27, 0.9)"
              max-height="75"
              height="75"
              elevation="3"
              dense
              dark
            >
              <v-toolbar-title>
                Users
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <div>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  outlined
                  class="mr-1"
                  v-on:change="searchProduct"
                ></v-text-field>
              </div>

              <v-btn
                class="ma-2"
                outlined
                color="white"
                value="Go Back From Whence You Came!"
                onclick="history.back(-1)"
              >
                <p class="btn-text">Previous</p>
              </v-btn>

              <v-btn
                elevation="2"
                outlined
                dark
                depressed
                color="white"
                @click="openForm"
                >Create User</v-btn
              >
            </v-app-bar>
            <v-data-table
              class="theme-bg-card-2"
              :loading="tableLoader"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="usersList"
              :search="search"
              max-width="750"
              id="virtual-scroll-table"
              v-scroll:#virtual-scroll-table="onScroll"
            >
              <template v-slot:item.controls="props">
                <i
                  class="fa fa-trash thrash"
                  @click="deleteConfirmation(props.item)"
                ></i>
                <i
                  class="fa fa-pencil thrash"
                  @click="editUser(props.item)"
                  style="margin-left: 20px"
                ></i>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </div>

      <v-dialog v-model="showConfirmation" max-width="290">
        <v-card class="theme-bg-card-2">
          <v-card-title class="text-h5">
            Are you sure you want to delete this user?
          </v-card-title>

          <v-card-text :v-if="itemToBeDeleted._id">
            User: {{ itemToBeDeleted.userName }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="showConfirmation = false"
            >
              Disagree
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              :loading="loading3"
              :disabled="loading3"
              @click="deleteUser()"
            >
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="overlay" opacity="0.98" z-index="9">
        <v-card
          v-scroll.self="onScroll"
          style="background-color: rgba(48, 64, 87, 0.8)"
          class="overflow-y-auto popup-container theme-bg-card-3"
        >
          <v-layout row wrap fluid>
            <v-flex xs12 sm12 md12>
              <v-list-item class="mb-margin">
                <v-list-item-content>
                  <v-form
                    ref="userform"
                    lazy-validation
                    aria-autocomplete="off"
                  >
                    <v-banner
                      class="justify-center text-h5 font-weight-light"
                      sticky
                    >
                      <v-avatar size="70">
                        <img src="@/assets/UserIcon.png" />
                      </v-avatar>
                      Users
                    </v-banner>

                    <h6 class="display-6 font-weight-thin">
                      General Information
                    </h6>

                    <v-row>
                      <v-text-field
                        v-model="formFields.firstName"
                        class="mg-lr14"
                        label="First Name"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.lastName"
                        class="mg-lr14"
                        label="Last Name"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-select
                        v-model="formFields.department"
                        class="mg-lr14"
                        :items="department"
                        label="Department"
                        outlined
                        required
                      ></v-select>
                      <v-select
                        v-model="formFields.position"
                        class="mg-lr14"
                        :items="position"
                        label="Position"
                        outlined
                        required
                      ></v-select>
                      <v-select
                        v-model="formFields.role"
                        class="mg-lr14"
                        :items="role"
                        label="Role"
                        outlined
                        required
                      ></v-select>
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="formFields.mobile"
                        class="mg-lr14"
                        label="Mobile"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.email"
                        class="mg-lr14"
                        label="Company Email"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.extension"
                        class="mg-lr14"
                        label="Extension"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mx-2"
                        color="red"
                        outlined
                        @click="resetForm()"
                        >Cancel</v-btn
                      >
                      <v-btn
                        class="mx-2"
                        color="green"
                        v-if="!editForm"
                        :loading="loading3"
                        :disabled="loading3"
                        outlined
                        @click="submitForm"
                        >Save</v-btn
                      >
                      <v-btn
                        class="mx-2"
                        color="green"
                        v-if="editForm"
                        :loading="loading3"
                        :disabled="loading3"
                        outlined
                        @click="updateUser"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
        </v-card>
      </v-overlay>
    </v-content>
  </vue-page-transition>
</template>

<script>
export default {
  name: 'Users',
  components: {},
  data() {
    return {
      scrollInvoked: 0,
      department: [
        'Retail',
        'Telemarketing',
        'Marketing',
        'Processing',
        'Repair'
      ],
      position: [
        'Sales Associate',
        'Repair Technician',
        'Chief Executive Officer',
        'Chief Sales Officer',
        'Chief Operations Officer',
      ],
      role: ['Adminstrator', 'Manager', 'Employee', 'Executive'],
      items: [],
      userInfo: {},
      usersList: [],
      searchKey: '',
      search: '',
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      overlay: false,
      rows: 100,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: '',
      formFields: {
        firstName: '',
        lastName: '',
        department: '',
        position: '',
        role: '',
        mobile: '',
        email: '',
        extension: '',
      },
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: ' Name',
          value: 'fullName',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: 'Department',
          value: 'department',
          align: 'center',
          divider: true,
        },
        { text: 'Position', value: 'position', align: 'center', divider: true },
        {
          text: 'Role',
          value: 'role',
          align: 'center',
          divider: true,
        },
        { text: 'Mobile', value: 'mobile', align: 'center', divider: true },
        {
          text: 'Email',
          value: 'email',
          align: 'center',
          divider: true,
        },
        {
          text: 'Extension',
          value: 'extension',
          align: 'center',
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: true,
          divider: true,
        },
      ],
    };
  },

  mounted() {
    this.getUsersList();
    let profile = JSON.parse(localStorage.getItem('currentUser'));
    this.userInfo = profile;
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/users') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('What is the user');
        this.startListining();
      }, 3000);
      this.overlay = true;
    });

    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/users') {
        return;
      }
      console.log(data.msg);
      this.editUser(this.usersList[0]);
    });

    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/users') {
        return;
      }
      this.search = data.msg;
      this.searchUser(data.msg);
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printLead: function() {
    window.print();
  },

  methods: {
    initialize() {
      this.usersList = [];
    },

    onScroll() {
      this.scrollInvoked++;
    },

    searchUser: async function() {
      console.log(this.search);
      if (!this.search) this.getUsersList();

      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;

      console.log(json);
      this.usersList = json.result;
    },

    getUsersList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/all`
      );
      const json = await response.json();
      console.log(json);
      this.usersList = json.result;
      this.tableLoader = false;
    },

    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])

      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('User Created');
        this.getUsersList();
        this.resetForm();
      }, 800);
    },

    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },

    deleteUser: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;

      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getUsersList();
      }, 800);
    },

    editUser: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
    },

    updateUser: async function() {
      this.loading3 = true;

      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getUsersList();
        this.resetForm();
      }, 800);
    },

    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        firstName: '',
        lastName: '',
        department: '',
        position: '',
        role: '',
        mobile: '',
        email: '',
        extension: '',
      };
    },

    openForm: function() {
      this.overlay = true;
      this.items = [];
    },

    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1250);
    },

    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },

    dateCommand: function(msg) {
      let date;
      var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      if (month < 9) {
        month = '0' + month;
      }
      var year = currentDate.getFullYear();
      switch (msg) {
        case 'today':
          date = new Date().toISOString().slice(0, 10);
          break;
        case 'tomorrow':
          date = year + '-' + month + '-' + (day + 1);
          break;
        default:
          msg = msg + ' ' + year;
          date = new Date(msg).toISOString().slice(0, 10);
          console.log(date);
          break;
      }

      return date;
    },

    fillForm: function(msg) {
      let firstChar = msg.charAt(0).toUpperCase();
      switch (this.currentField) {
        case 0:
          this.formFields.firstName = msg;
          break;
        case 1:
          this.formFields.lastName = msg;
          break;
        case 2:
          this.formFields.department = this.priority.filter(
            (obj) => obj.indexOf(firstChar) != -1
          )[0];
          break;
        case 3:
          this.formFields.position = this.status.filter(
            (obj) => obj.indexOf(firstChar) != -1
          )[0];
          break;
        case 4:
          this.formFields.role = this.status.filter(
            (obj) => obj.indexOf(firstChar) != -1
          )[0];
          break;
        case 5:
          this.formFields.mobile = msg;
          break;
        case 6:
          this.formFields.email = msg;
          break;
        case 7:
          this.formFields.extension = msg;
          break;
      }

      this.currentField++;
      this.navigateField();
    },

    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('First Name?');
          break;
        case 1:
          this.readOutLoud('Last Name?');
          break;
        case 2:
          this.readOutLoud('Department?');
          break;
        case 3:
          this.readOutLoud('Position?');
          break;
        case 4:
          this.readOutLoud('Role?');
          break;
        case 5:
          this.readOutLoud('Mobile?');
          break;
        case 6:
          this.readOutLoud('Email?');
          break;
        case 7:
          this.readOutLoud('Extension?');
          break;
      }

      this.startListining();
    },
  },
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
</style>